import type { RouteRecordRaw } from 'vue-router'

import { generateWebviewRoutes } from '~/scopes/webviews/generateWebviewRoutes'
import redirectIfWebview from '~/scopes/webviews/middleware/redirectIfWebview'

import { CMS } from '../cms/routes-names'

export default (): RouteRecordRaw[] => {
  const discountRoutes: RouteRecordRaw[] = [
    {
      path: 'military-discount',
      name: CMS.MILITARY_DISCOUNT,
      component: () => import('~/scopes/cms/Landing.vue'),
      props: {
        simpleLayout: true,
      },
      meta: {
        owners: ['bot-squad-lifecycle-front'],
        middleware: [redirectIfWebview],
      },
    },
    {
      path: 'student-discount',
      name: CMS.STUDENT_DISCOUNT,
      component: () => import('~/scopes/cms/Landing.vue'),
      props: {
        simpleLayout: true,
      },
      meta: {
        owners: ['bot-squad-lifecycle-front'],
        middleware: [redirectIfWebview],
      },
    },
  ]

  const webviewDiscountRoutes = generateWebviewRoutes(discountRoutes)

  return [...discountRoutes, ...webviewDiscountRoutes]
}
